import { FC, Fragment, useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { DEFAULT_SECTION } from './ManageCustomPage';
import { ICustomPageSection, SectionType } from '../../../models';
import { createCustomPageImage } from '../../../fetch';
import { ImageUpload } from '../../../components';
import { getRandomNegativeNumber } from '../../../helpers';
import { Grid, TextField, Typography } from '@mui/material';

interface IHeroSection {
  setSections: (val: ICustomPageSection[]) => void;
  parentSections: ICustomPageSection[];
  parentIndex: number;
  sections: ICustomPageSection[];
  index: number;
}

export const HeroSection: FC<IHeroSection> = ({ index, sections, parentSections, setSections, parentIndex }) => {
  // use this to deeply copy sections so we don't modify the original array
  const copy: ICustomPageSection[] = JSON.parse(JSON.stringify(parentSections));
  const classes = useStyles();

  useEffect(() => {
    if (copy[parentIndex].sections[index].sections.length < 1) {
      const randomNumber = getRandomNegativeNumber();
      copy[parentIndex].sections[index].sections.push({
        ...DEFAULT_SECTION,
        text: null,
        customPageSectionId: randomNumber,
        type: SectionType.HERO,
        sortOrder: copy[parentIndex].sections[index].sections.length + 1
      });
      setSections(copy);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Typography variant="h6">Hero Section</Typography>
      <Typography variant="caption" component="p" paragraph>
        Add full width hero image as a banner with alt text. Recommended image size is 1920px wide by 633px tall, at 72dpi resolution.
      </Typography>
      <Grid container spacing={1}>
        {sections.map((item, subSectionIndex: number) => {
          const heroItem = copy[parentIndex].sections[index].sections[subSectionIndex];
          return (
            <Fragment key={`${subSectionIndex}`}>
              <Grid item xs={12}>
                <ImageUpload
                  labelClassName={classes.labelClassName}
                  handleFileChange={async (_, file) => {
                    // remove image
                    if (!file) {
                      heroItem.imageUrl = '';
                    } else {
                      const formData = new FormData();
                      formData.append('File', file);
                      const imageUrl = await createCustomPageImage(formData);
                      heroItem.imageUrl = imageUrl;
                    }
                    setSections(copy);
                  }}
                  imageKey={`${subSectionIndex}`}
                  image={item.imageUrl}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  label="Image Alt Text"
                  autoComplete="nope"
                  variant="outlined"
                  value={item.text}
                  fullWidth
                  sx={{ marginBottom: '0.75rem' }}
                  onChange={e => {
                    heroItem.text = e.target.value;
                    setSections(copy);
                  }}
                />
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  labelClassName: {
    marginTop: 0
  }
}));
